<template>
    <div class="side_buttons" v-bind:class="{ active: isActive }" v-on:click="openAction">
        <a class="more_btn"><i class="fa-solid fa-angle-right"></i></a>
        <button type="button" class="btn btn-secondary btn-sm" @click="submit('Edit')">Edit</button>
        <!--<button type="button" class="btn btn-secondary btn-sm" @click="submit('Delete')">Delete</button>!-->
        <button type="button" class="btn btn-secondary btn-sm" @click="submit('Duplicate')">Duplicate</button>
    </div>
</template>
<script>
export default {
    name:"more-btn",
    data(){
        return{
             isActive:false,
        }
    },

    methods: {
        openAction() {
            this.isActive = !this.isActive;
        },
        submit(){

        }
    },
}
</script>
